import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Blog, BlogDetailsTitle } from "../../../../Constants/Constants";
import BlogFilter from "../BlogGrids/BlogFilter/BlogFilter";
import BlogBody from "./BlogBody/BogBody";

const BlogDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BlogDetailsTitle} parent={Blog} />
      <Container fluid className="blog-detail-page">
        <Row>
          <BlogBody />
          <BlogFilter />
        </Row>
      </Container>
    </>
  );
};

export default BlogDetailsContainer;
